@let isUnassignedRegionExpanded = isUnassignedRegionExpanded$ | async;
@let maxHeight = maxHeight$ | async;
@let isMoveMode = dragAndDropModeService.isMoveMode$ | async;
@let isAssignmentMode = dragAndDropModeService.isAssignmentMode$ | async;
@let defaultUnassignedSectionHeight = defaultUnassignedSectionHeight$ | async;
@let maxRowIndex = maxRowIndexSignal();
@let shiftRowIndexMap = shiftRowIndexMapSignal();
@let shiftColorOption = shiftColorOption$ | async;
@let staffLayoutStyle = staffLayoutStyle$ | async;

<div
  [style.--dynamic-row-height.px]="rowHeight"
  [style.--time-column-width.px]="pixelWidthPerDay"
  [style.height.px]="isUnassignedRegionExpanded ? maxHeight : 0"
  [style.min-height.px]="defaultUnassignedSectionHeight"
  class="unassigned-items-row"
>
  <div
    #unassignedItemsContainer
    [style.height.px]="rowHeight * (maxRowIndex + 1)"
    class="internal-grid"
  >
    <wilson-dates-demarcator-lines
      [leftMarginPx]="0"
      [panelWidth]="(frameLength$ | async) || 0"
      [interval]="timeframe$ | async"
      [visibleDaysRange]="visibleDaysRange$ | async"
      [holidayRegions]="null"
    ></wilson-dates-demarcator-lines>
    <ng-container
      *rxFor="
        let shift of visibleShiftsSignal();
        let isLastShiftInRow = last;
        trackBy: trackByShiftId
      "
    >
      <wilson-unassigned-shift-without-activities
        class="grid-item"
        [style.transform]="
          'translateY(' + shiftRowIndexMap[shift.id] * rowHeight + 'px)'
        "
        [class]="['grid-item--row-' + shiftRowIndexMap[shift.id]]"
        [staffLayoutStyle]="staffLayoutStyle"
        [shiftColorOption]="shiftColorOption"
        [shift]="shift"
        [isMoveMode]="!!isMoveMode"
        [isAssignmentMode]="!!isAssignmentMode"
        [isLastShiftInLastRow]="isLastShiftInRow"
        [shiftHeight]="rowHeight"
      ></wilson-unassigned-shift-without-activities>
    </ng-container>
  </div>
</div>
